/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';
import { getAuthToken } from '@ihsm/ui-shared';
import { ENV_CONFIG } from 'constants/environment';

type AwsPoolData = { UserPoolId: string; ClientId: string };
export interface AuthState {
  token: string;
  userEmail: string;
  awsPoolData: AwsPoolData;
  loginRequired: boolean;
  apiAuthTokenRequired: boolean;
}

export const initialUiState: AuthState = {
  token: getAuthToken() || '',
  userEmail: '',
  loginRequired: ENV_CONFIG().LOGIN_REQUIRED,
  apiAuthTokenRequired: ENV_CONFIG().API_AUTH_TOKEN_REQUIRED,
  awsPoolData: {
    UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
  },
};

export const authSlice: Slice<AuthState> = createSlice({
  name: 'authSlice',
  initialState: initialUiState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    setUserEmail: (state, action: PayloadAction<string>) => {
      state.userEmail = action.payload;
    },
  },
});

export const { setToken, setUserEmail } = authSlice.actions;
